import { render, staticRenderFns } from "./campaignEdit.vue?vue&type=template&id=4e2b9c0c&scoped=true&"
import script from "./campaignEdit.vue?vue&type=script&lang=js&"
export * from "./campaignEdit.vue?vue&type=script&lang=js&"
import style0 from "./campaignEdit.vue?vue&type=style&index=0&id=4e2b9c0c&prod&scoped=true&lang=css&"
import style1 from "./campaignEdit.vue?vue&type=style&index=1&id=4e2b9c0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2b9c0c",
  null
  
)

export default component.exports